import {
  type OrderItemInteractiveFieldEnum,
  OrderItemInteractiveFields,
} from '../../../entities/enums/OrderItemInteractiveFieldEnum'
import {
  type OrderDraftItemFieldError,
  type OrderDraftItemFieldErrors,
} from '../../types/OrderDraftItemFieldErrors'

interface IGetActiveOrderDraftItemFieldErrorsUseCaseProps {
  fieldErrors: OrderDraftItemFieldErrors | undefined
  currencyId: number | undefined
  vendorId: number | undefined
}

export type ActiveOrderDraftItemFieldErrors = Partial<
  Record<OrderItemInteractiveFieldEnum, OrderDraftItemFieldError>
>

/** Keeps the stored errors whose rejected id the item still holds; picking another value retires an error. */
export class GetActiveOrderDraftItemFieldErrorsUseCase {
  execute = ({
    fieldErrors,
    currencyId,
    vendorId,
  }: IGetActiveOrderDraftItemFieldErrorsUseCaseProps): ActiveOrderDraftItemFieldErrors => {
    const currencyError = fieldErrors?.[OrderItemInteractiveFields.CURRENCY]
    const vendorError = fieldErrors?.[OrderItemInteractiveFields.VENDOR]

    return {
      ...(currencyError &&
        currencyError.currencyId === currencyId && {
          [OrderItemInteractiveFields.CURRENCY]: currencyError,
        }),
      ...(vendorError &&
        vendorError.vendorId === vendorId && {
          [OrderItemInteractiveFields.VENDOR]: vendorError,
        }),
    }
  }
}
